@use "~theme/typography";
@use "~theme/breakpoints";
@use "~components/Navbar/tokens" as navbar;

.container {
  max-width: 300px;
  padding: 8px 32px 8px 12px;
}

.text {
  @include typography.body;
}

.link {
  @include typography.body-semibold;
  @include typography.light-link;
  margin-top: 4px;
}

.btnLink[type="button"] {
  @include typography.body-semibold;
  @include typography.light-link;
  margin-top: 0;
  border: none;
  background: none;
  padding: 0;
  text-transform: none;
  letter-spacing: normal;
  margin-left: -5px;

  &:disabled {
    cursor: auto;
    background: none;
  }

  &:not(:disabled):hover {
    background: none;
  }

  &:not(:disabled):active {
    background: none;
    box-shadow: none;
  }
}

.toast {
  top: auto;
  left: 16px;
  right: 16px;
  bottom: 16px;
  margin: auto;

  @include breakpoints.desktop {
    bottom: auto;
    left: auto;
    top: calc(#{navbar.$nav-height-desktop} + 10px);
    right: var(--desktop-gutter);
  }
}

.bagIcon {
  width: 24px;
  height: 24px;
}

.noLocationFound {
  @include typography.small-text;
  padding-left: 2px;
}
